/**
 * Labstep
 *
 * @module components/PermaLink/Action/Copy
 * @desc Action to copy permalink in clipboard
 */

import { ActionCopy } from 'labstep-web/core/Action/Copy';
import type React from 'react';
import type { IPermaLinkActionCopyProps } from './types';

export const PermaLinkActionCopy: React.FC<
  IPermaLinkActionCopyProps
> = ({ entity }) => (
  <ActionCopy
    text={entity.permaLinkUrl}
    actionComponentProps={{ type: 'icon', icon: 'linkify' }}
    hoverContent="Copy Permalink"
  />
);
